import React from 'react';
import createInlineStyleButton from './util/createInlineStyleButton';

export default createInlineStyleButton({
  style: 'SUPERSCRIPT',
  children: (
    <i className="fa fa-superscript" aria-hidden="true"></i>
  ),
});
